export const BackArrow = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.73398 3.2207C7.87535 3.2207 8.01093 3.27704 8.11093 3.37695C8.21087 3.4769 8.2671 3.61258 8.26718 3.75391C8.26718 3.89535 8.21095 4.03182 8.11093 4.13184C8.01094 4.23165 7.87527 4.28711 7.73398 4.28711H1.06699C0.925732 4.28702 0.78996 4.23168 0.690033 4.13184C0.590014 4.03182 0.533783 3.89535 0.533783 3.75391C0.533869 3.61257 0.59009 3.4769 0.690033 3.37695C0.789976 3.27701 0.925655 3.22079 1.06699 3.2207H7.73398Z"
        fill="black"
        stroke="black"
        stroke-width="0.4"
      />
      <path
        d="M3.73398 0.219971C3.87536 0.219985 4.01088 0.276351 4.11093 0.376221C4.21103 0.47632 4.26816 0.612591 4.26816 0.75415C4.2681 0.895627 4.21098 1.03106 4.11093 1.1311L1.48788 3.75317L4.11093 6.37622C4.21103 6.47632 4.26816 6.61259 4.26816 6.75415C4.2681 6.89563 4.21098 7.03106 4.11093 7.1311C4.01085 7.23113 3.87548 7.28734 3.73398 7.28735C3.59242 7.28735 3.45615 7.2312 3.35605 7.1311L0.356049 4.1311L0.357025 4.13013C0.307604 4.08069 0.267606 4.02282 0.240814 3.95825C0.213966 3.89354 0.199829 3.82421 0.199799 3.75415C0.199799 3.684 0.213927 3.61387 0.240814 3.54907C0.267697 3.48444 0.307462 3.42566 0.357025 3.37622H0.356049L3.35605 0.376221C3.45615 0.276122 3.59242 0.219971 3.73398 0.219971Z"
        fill="black"
        stroke="black"
        stroke-width="0.4"
      />
    </svg>
  );
};
